import { useRouter } from "next/router";
import Button from "../buttons/Button";

type Props = React.ComponentPropsWithoutRef<typeof Button>;
const LoginButton: React.FC<Props> = ({
  children = "Sign in",
  ...buttonProps
}) => {
  const router = useRouter();
  const href = `/api/auth/login?returnTo=${encodeURIComponent(router.asPath)}`;
  return (
    <Button {...buttonProps} as="a" href={href} data-login-button>
      {children}
    </Button>
  );
};

export default LoginButton;
